<template>
  <v-select v-model="select" :items="items" :label="label" :rules="rules" :color="color" :item-text="itemText" :item-value="itemValue" @change="changeValue" :disabled="disabled" dense outlined></v-select>
</template>

<script>
export default {
  name: "RyouSelect",
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: String,
      required: false,
      default: ""
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    color: {
      type: String,
      required: false,
      default: ""
    },
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    itemText: {
      type: String,
      required: false
    },
    itemValue: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
     }
  },
  data() {
    return {};
  },
  method: {},
  methods: {
    changeValue() {
      this.$emit("selectValue", this.select);
    }
  },
  computed: {
    select: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style>
</style>
